import React from "react";
import Form from "react-bootstrap/Form";
import MicImg from "../../Assets/Images/mic.svg";
import { GoArrowUp } from "react-icons/go";
import { FiPlus } from "react-icons/fi";

function ChatInput({
  message,
  setMessage,
  sendMessage,
  handleMicToggle,
  isListening,
  isResponsePending,
  isAITyping,
  micSupported,
  onPdfClick,
  inputRef
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isResponsePending && !isAITyping && message.trim()) { sendMessage() }
    }
  };

  const isDisabled = isResponsePending || isAITyping;

  return (
    <div className="d-flex message_write_box">
      <Form.Group className="cst_message_input_wrap" style={{ position: 'relative', width: '100%' }}>
        <Form.Control
          as="textarea"
          placeholder="Enter Message..."
          value={message}
          style={{
            height: "70px",
            resize: "none",
            fontSize: "13px",
            textAlign: "left",
            padding: "14px",
            paddingRight: "10rem",
          }}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isDisabled}
          ref={inputRef}
        />

        <div
          className={`up_arr pdf_upload_btn`}
          onClick={onPdfClick}
          title="Upload PDF"
          style={{
            cursor: "pointer",
            position: 'absolute',
            right: "5.5rem",
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10
          }}
        >
          <FiPlus />
        </div>

        <div
          className={`up_arr ${isDisabled || !message.trim() ? "disabled" : ""}`}
          onClick={() => { if (!isDisabled && message.trim()) sendMessage(); }}
          style={{
            cursor: isDisabled || !message.trim() ? "not-allowed" : "pointer",
            opacity: isDisabled || !message.trim() ? 0.5 : 1,
            position: 'absolute',
            right: "2rem",
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10
          }}
        >
          <GoArrowUp />
        </div>

        {isListening && <div className="mic-active-indicator" />}
      </Form.Group>

      <div
        className="mic_box"
        onClick={handleMicToggle}
        style={{
          cursor: !micSupported || isDisabled ? "not-allowed" : "pointer",
          opacity: !micSupported || isDisabled ? 0.5 : 1,
          marginLeft: '10px'
        }}
      >
        <img
          src={MicImg}
          alt="Microphone"
          className="img-fluid"
          style={{
            filter: isListening ? "invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)" : "none"
          }}
        />
      </div>
    </div>
  );
}

export default ChatInput;